import { render, staticRenderFns } from "./ServiceAssignment.vue?vue&type=template&id=45aa6ceb&"
import script from "./ServiceAssignment.vue?vue&type=script&lang=js&"
export * from "./ServiceAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports